var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaturate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 1a11 11 0 1 0 11 11 11.0066 11.0066 0 0 0 -11-11zm4.7074 7.7068-8.0006 8.0006a1 1 0 0 1 -1.4142-1.4142l8.0006-8.0006a1 1 0 0 1 1.4142 1.4142z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturate);
export default __webpack_public_path__ + "static/media/Saturate.6ee8cc2dba841560f3d231dc38483131.svg";
export { ForwardRef as ReactComponent };